"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../../../utils/utils");
var RawDraftContentBuilder_1 = require("./RawDraftContentBuilder");
var ContentConverter = /** @class */ (function () {
    function ContentConverter() {
    }
    ContentConverter.parseText = function (contentString) {
        try {
            var converter = new ContentConverter();
            var rawContent = converter.parseDraftJsFromString(contentString);
            var text = rawContent.blocks
                .filter(function (b) { return b.text && b.text.trim(); })
                .map(function (block) { return block.text.trim(); })
                .join(' ');
            return text;
        }
        catch (e) {
            return contentString;
        }
    };
    ContentConverter.parseContentString = function (input) {
        var converter = new ContentConverter();
        try {
            return converter.parseContentStateString(input);
        }
        catch (e) {
            return converter.parseContentStateString('');
        }
    };
    ContentConverter.prototype.parseDraftJsFromString = function (input) {
        var draftJs;
        try {
            draftJs = JSON.parse(input);
            if (utils_1.isObject(draftJs)) {
                return draftJs;
            }
        }
        catch (e) {
            return draftJs;
        }
    };
    ContentConverter.prototype.parseContentStateString = function (input) {
        var draftJs = this.parseDraftJsFromString(input) || this.convertToRaw(input);
        return draftJs;
    };
    ContentConverter.prototype.convertToRaw = function (input) {
        var builder = new RawDraftContentBuilder_1.RawDraftContentBuilder().withText(input);
        return builder.build();
    };
    return ContentConverter;
}());
exports.ContentConverter = ContentConverter;
//# sourceMappingURL=ContentConverter.js.map